import React from "react";
import Label from "components/general/Label"
import Card from 'react-bootstrap/Card';
import DateTime from "components/presentation/DateTime"
import Status from "components/presentation/Status";
import { isLiveStatus, isLessLiveStatus } from "helpers/status";


export function Footer({ data }) {

    const formatDate = Label({ data: 'BracketDateFormat' });
    const formatDateTime = Label({ data: 'BracketDateTimeFormat' });
    const dateTime = data?.bi_date + ' ' + data?.bi_time
    const dateTimeFormated = data?.bi_date && <DateTime datetime={dateTime} format={formatDateTime} />
    const date = data?.bi_date && <><DateTime datetime={data?.bi_date} format={formatDate} />, TBD</>
    const time = data?.bi_time && <DateTime datetime={dateTime} format={"HH:mm"} />
    const dateComponent = data?.bi_time ? dateTimeFormated : date
    const numberGame = data?.bracketItemCode

    return (
        <>
            {isLiveStatus(data?.result?.status?.code) && <div className='score-status justify-content-end'>
                <Status typeToPrint={'result'} scheduleStatus={data?.schedule?.status?.code} resultStatus={data?.result?.status?.code} />
            </div>}
            <div className="d-flex w-100">
                {isLessLiveStatus(data?.result?.status?.code) && <div className='text-start w-40'>{dateComponent}</div>}
                {isLessLiveStatus(data?.result?.status?.code) && <div className='text-end w-60'><Label data='HeaderGame' /> {numberGame}</div>}
            </div>
        </>
    )
}

export function CompetitorBlockNoData(competitor) {
    let prev_pos = <>{' ' + competitor.cp_prev_pos}</>
    return (
        <div className='score-competitor-container  d-flex flex-row justify-content-start'>
            <div className='score-name'>
                {!competitor.cp_prev_wlt
                    ? competitor?.cp_prev_pos
                    : competitor?.cp_prev_wlt === 'W'
                        ? <><Label data='HeaderWinner' /><>{prev_pos}</></>
                        : <><Label data='LabelLooserDesc' /><>{prev_pos}</></>
                }
            </div>
        </div>
    )
}

export function Header({ data, bracket, phase }) {
    return (
        <Card.Header className={data?.code !== 'CLEAN' && bracket === 'FNL' && phase === 'FNL-' ? 'visible' : 'invisible'}>
            <div className='score-header'>
                <strong><span>{data?.eventUnit?.shortDescription}</span></strong>
            </div>
        </Card.Header>
    )
}